import moment from 'moment';
import getArrayTrueElementsCount from './getArrayTrueElementsCount';
import getFormData from './getFormData';
import { PHOTOS_COUNT } from './constants';
import isValidDate from './isValidDate';
import checkCoordinates from './checkCoordinates';

function checkAddEventPayload({
  owner_id,
  name,
  country_id,
  city_id,
  specialization,
  address,
  coordinates,
  holding_date,
  date_start,
  date_end,
  contacts,
  description,
  photos,
  withPhotos = true,
}) {
  const errors = [];

  if (owner_id?.length !== 24) {
    errors.push(' * неправильный формат ID пользователя (24 символа)');
  }
  if (name.length < 2) {
    errors.push(' * название не меньше 2 символов');
  } else if (name.length > 100) {
    errors.push(' * название не больше 100 символов');
  }
  if (specialization.length < 2) {
    errors.push(' * специализация не меньше 2 символов');
  }
  if (holding_date?.length < 2) {
    errors.push(' * дата проведения не меньше 2 символов');
  }
  if (city_id) {
    if (address.length < 2) {
      errors.push(' * адрес не меньше 2 символов');
    }
    if (!checkCoordinates(coordinates?.lat, coordinates?.lon)) {
      errors.push(' * не валидные координаты');
    }
  }
  if (getArrayTrueElementsCount(Object.values(contacts)) < 1) {
    errors.push(' * укажите хотя бы один из методов контакта с вами');
  }
  if (description.length < 2) {
    errors.push(' * описание не меньше 2 символов');
  }
  if (withPhotos && photos.length < PHOTOS_COUNT.carouselMin) {
    errors.push(` * выберите хотя бы ${PHOTOS_COUNT.carouselMin} фото`);
  } else if (withPhotos && photos.length > 15) {
    errors.push(' * выберите не больше 15 фото');
  }

  if (errors.length) {
    return { errors };
  }

  const payload = {
    owner_id,
    name,
    country_id,
    city_id,
    holding_date,
    specialization,
    address,
    contacts,
    description,
  };

  if (isValidDate(new Date(date_start))) payload.date_start = moment.utc(date_start, 'YYYY-MM-DD').startOf('day').toISOString();
  if (isValidDate(new Date(date_end))) payload.date_end = moment.utc(date_end, 'YYYY-MM-DD').startOf('day').toISOString();

  console.log(city_id, coordinates);
  if (city_id) {
    payload.lat = coordinates?.lat ? coordinates.lat.toString() : '0';
    payload.lon = coordinates?.lon ? coordinates.lon.toString() : '0';
    payload.is_special_point_on_map = Boolean(coordinates?.is_special_point_on_map);
  }

  console.log(payload);
  if (withPhotos) {
    const formData = getFormData(payload, photos);
    return { formData };
  }
  return { payload };
}

export default checkAddEventPayload;
